export const initialState = {
    devices: [],
    current: {
        cameraId: null,
        microphoneId: null,
        speakerId: null,
        facingMode: null,
    },
    isModalDisableCameraOpen: false,
    hasCameraAccess: null,
    hasMicrophoneAccess: null,
};
export const devicesReducer = (state = initialState, { type, payload } = {}) => {
    switch (type) {
        case 'DEVICES/SET_DEVICES':
            return { ...state, devices: payload };
        case 'DEVICES/SET_CURRENT_DEVICES':
            return { ...state, current: payload };
        case 'DEVICES/TOGGLE_MODAL_DISABLE_CAMERA':
            return { ...state, isModalDisableCameraOpen: payload };
        case 'DEVICES/SET_CAMERA_ACCESS':
            return { ...state, hasCameraAccess: payload };
        case 'DEVICES/SET_MICROPHONE_ACCESS':
            return { ...state, hasMicrophoneAccess: payload };
        default:
            return state;
    }
};
export default devicesReducer;
